<template>
  <div class="max-w-sm md:mr-2 lg:mx-6">
    <pdl-callout v-if="error" kind="warning" role="alert" aria-live="assertive">
      <template #content>
        <span v-html="error" />
      </template>
    </pdl-callout>
    <form action="#" :class="{'opacity-50': isLoading}" autocomplete="on" @submit.prevent="onSubmit">
      <fieldset>
        <legend class="text-lg font-semibold mb-2">
          {{ $t('guest.checkout') }}
        </legend>

        <pdl-form-group
          v-model="email"
          type="email"
          name="email"
          :label="$t('guest.email')"
          required
          autocomplete="email"
          qaid="guest-email-input"
          :error="getErrorMessage('email')"
        />

        <trek-button primary :disabled="isLoading" type="submit" @click="onSubmit">
          <span v-html="$t('checkout.login.guestCheckout')"></span>
        </trek-button>
      </fieldset>
    </form>
  </div>
</template>
<script>
import TrekButton from '@/components/TrekButton';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {PdlCallout} from '@pedal/pdl-callout';
import {UserApi} from '@/api/user';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
import {focusElement} from '@/utils/accessibility/a11y-utils';

export default {
  name: 'GuestCheckout',
  components: {PdlFormGroup, TrekButton, PdlCallout},
  mixins: [TrekValidationMixin],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      email: {
        required: this.trekValidators.required('login.email'),
        email: this.trekValidators.email('login.email'),
      },
    };
  },
  data() {
    return {
      isLoading: false,
      email: '',
      error: '',
    };
  },
  watch: {
    isLoading(value) {
      if (value) {
        this.error = '';
      }
    },
  },
  methods: {
    getFormData() {
      return {
        email: this.email,
        CSRFToken: this.options.CSRFToken,
      };
    },
    async processGuestLogin() {
      try {
        this.isLoading = true;
        this.handleResponse(await UserApi.guestLogin(this.getFormData()));
      } catch (e) {
        this.error = this.$t('server.error');
        this.isLoading = false;
      }
    },
    handleResponse(redirectUrl) {
      if (!redirectUrl || redirectUrl.indexOf('error=true') > -1) {
        this.error = this.$t('server.error');
        this.isLoading = false;
      } else {
        window.location.href = redirectUrl;
      }
    },
    onSubmit() {
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          this.processGuestLogin();
        } else {
          focusElement(document.querySelector('.has-error'));
        }
      });
    },
  },
};
</script>
